import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-bootstrap',
	templateUrl:'./BootstrapPluginPage.html',
	styles: [],
	styleUrls:['./BootstrapPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class BootstrapPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_528 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>bootstrap</artifactId>
</dependency>
\`\`\``;
	mdContent_529 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:bootstrap:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_530 = `\`\`\`json
"bootstrap": "^5.3.8"
"@ng-bootstrap/ng-bootstrap": "^20.0.0"
"@angular/localize": "^21.0.0"
"@popperjs/core": "*"
\`\`\``;
	mdContent_531 = `\`\`\`java
BSCard<?> card = new BSCard<>();
card.addCardHeader("Header");
card.addCardBody("Content");
card.addCardFooter("Footer");
\`\`\``;
	mdContent_532 = `\`\`\`java
BSModal<?> modal = new BSModal<>();
modal.addTitle("Confirm");
modal.addModalBody("Are you sure?");
modal.addDismissButton("Cancel");
modal.addPrimaryButton("OK");
\`\`\``;
	mdContent_533 = `\`\`\`java
BSNavBar<?> navbar = new BSNavBar<>();
navbar.addBrand("My App", "/");
navbar.addHeaderItem("Home", "/home");
navbar.addHeaderItem("About", "/about");
\`\`\``;
	mdContent_534 = `\`\`\`java
// Card component
BSCard<?> card = new BSCard<>();
card.addCardHeader("Header");
card.addCardBody("Content");
card.addCardFooter("Footer");

// Modal with events
BSModal<?> modal = new BSModal<>();
modal.addTitle("Confirm");
modal.addModalBody("Are you sure?");
modal.addDismissButton("Cancel");
modal.addPrimaryButton("OK");
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
